import { CoursePriceType } from './course-policy';

export const CoursePurchaseStatus = {
  COMPLETED: 'completed',
  REFUNDED: 'refunded',
} as const;

export type CoursePurchaseStatusValue =
  (typeof CoursePurchaseStatus)[keyof typeof CoursePurchaseStatus];

export const COURSE_CHECKOUT_FLOW = 'course_purchase';

export function computeCoursePlatformFeeCents(amountCents: number, feePercent: number): number {
  if (amountCents <= 0 || feePercent <= 0) return 0;
  return Math.round((amountCents * feePercent) / 100);
}

export function validateCourseCheckoutAcceptance(input: {
  priceType: string;
  refundPolicyText?: string | null;
  acceptRefundPolicy: boolean;
}): { ok: boolean; message?: string } {
  if (input.priceType !== CoursePriceType.ONE_TIME) {
    return { ok: false, message: 'This course is not available for purchase' };
  }
  if (!input.refundPolicyText?.trim()) {
    return { ok: false, message: 'Refund policy is required before checkout' };
  }
  if (!input.acceptRefundPolicy) {
    return { ok: false, message: 'Accept the refund policy to continue' };
  }
  return { ok: true };
}

export function paidCourseRequiresConnectReady(priceType: string): boolean {
  return priceType === CoursePriceType.ONE_TIME;
}
